<ng-container>
  <div class="flex">
    @if (startInd > 0) {
      <div
        class="float-left flex justify-center items-center mr-2"
        >
        <button class="focus:outline-none" (click)="scrollLeft()">
          <img src="assets/images/angel-left.svg" alt="backbtn" />
        </button>
      </div>
    }
    <div class="flex overflow-hidden">
      @for (row of displayList; track row; let i = $index) {
        <div
          class="w-8 h-8 rounded-3xl flex justify-center items-center bg-gray-300 text-xs mr-2 cursor-default"
          title="{{ row.fullName }}"
          >
          {{ row.shortName }}
        </div>
      }
    </div>
    @if (endInd < totalCount) {
      <div
        class="float-right flex justify-center items-center"
        >
        <button class="focus:outline-none" (click)="scrollRight()">
          <img src="assets/images/angel-right.svg" alt="forwardBtn" />
        </button>
      </div>
    }
  </div>
</ng-container>
